<div class="tw-mb-4 tw-flex tw-justify-end tw-gap-2">
  @if (canEdit) {
    <mh-core-lib-button
      #chainActionButton
      [text]="'customer.configurations.hotel.form.add_chain' | translate"
      [isPrimary]="true"
      [height]="35"
      (clicked)="goToCreateChain()"
      [width]="'auto'">
    </mh-core-lib-button>
  }
  <mh-core-lib-button
    #chainActionButton
    [text]="'customer.configurations.hotel.see_chains_manager' | translate"
    [isSecondary]="true"
    [height]="35"
    (clicked)="goToChainsManager()"
    [width]="'auto'">
  </mh-core-lib-button>
</div>
<div [formGroup]="parentForm" *ngIf="hotelDto">
  <div formGroupName="chain_property" class="row align-items-center">
    <ng-container *ngFor="let key of hotel_chain_property">
      <div class="col-3">
        <ng-container [ngSwitch]="key">
          <ng-template [ngSwitchCase]="(['chain'].includes(key) ? key : false )">
            <label>{{'models.hotel_dto.chain_property.chain' | translate}}</label>
            <mh-core-lib-search-select-input
              formControlName="chain"
              [options]="chainOptions"
              [loading]="chainSearchLoading"
              [filterMode]="'client'"
              [toOption]="chainToOption"
              [fromOption]="optionToChain"
              [placeholder]="('models.hotel_dto.chain_property.chain_search_placeholder' | translate)"
              (loadRequested)="onChainCatalogLoadRequested()">
            </mh-core-lib-search-select-input>
          </ng-template>

          <ng-template ngSwitchDefault>

            <label for="{{key}}">{{'models.hotel_dto.chain_property.'+key | translate}}</label>
            <input type="text" id="{{key}}" class="form-control" formControlName="{{key}}">

          </ng-template>
        </ng-container>
      </div>
    </ng-container>
  </div>

</div>
<ng-template #formAlerts let-element="element">
  <small class="alert-danger">
    <ng-container *ngIf="element.invalid && (element.dirty || element.touched)">
      <div *ngIf="element.errors.required">
        {{'forms.attributes.not_empty' | translate}}
      </div>
      <div *ngIf="element.errors.minlength">
        {{'forms.attributes.min_lenght' | translate:({length: element.errors.minlength.requiredLength})}}
      </div>

      <div *ngIf="element.errors.maxlength">
        {{'forms.attributes.max_lenght' | translate:({length: element.errors.maxlength.requiredLength})}}
      </div>
    </ng-container>
  </small>
</ng-template>

<ng-template #formTypes let-data="data">

</ng-template>
